import isEmpty from 'lodash/isEmpty';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/eds-button';
import { translationPropType } from '@eventbrite/i18n';

import SeatPin from './SeatPin';

import './VenueMapThumbnailView.scss';
import { SQUARE, WIDE, EXTRA_WIDE } from './constants';

const PERCENTAGE_UNIT = '%';

const SeatPinIcon = ({ x, y, isThumbnailImageLoaded }) => {
    const positionStyles = {
        left: `${x}${PERCENTAGE_UNIT}`,
        top: `${y}${PERCENTAGE_UNIT}`,
    };

    const pinContainerClassNames = classNames('venue-map-thumbnail__seat-pin', {
        'venue-map-thumbnail__seat-pin--hide': !isThumbnailImageLoaded,
    });

    return (
        <div
            className={pinContainerClassNames}
            style={positionStyles}
            data-spec="venue-map-thumbnail-seat-pin"
        >
            <SeatPin />
        </div>
    );
};

export default class VenueMapThumbnailView extends PureComponent {
    static propTypes = {
        thumbnailUrl: PropTypes.string.isRequired,
        seatPins: PropTypes.arrayOf(
            PropTypes.shape({
                x: PropTypes.number.isRequired,
                y: PropTypes.number.isRequired,
                size: PropTypes.string,
            }),
        ),
        showHideClass: PropTypes.string,
        fixedSize: PropTypes.oneOf([SQUARE, WIDE, EXTRA_WIDE]),
        /** If defined, wraps venue img in a Button with the provided click handler */
        onClick: PropTypes.func,

        /**Floating number, range from 0 to 1 */
        customRatio: PropTypes.number,
        __customContainerClassNames: PropTypes.string,
    };

    state = {
        isImageLoaded: false,
    };

    _handleImageLoad = () => {
        this.setState({
            isImageLoaded: true,
        });
    };

    render() {
        const {
            thumbnailUrl,
            seatPins,
            showHideClass,
            fixedSize,
            customRatio,
            onClick,
            __customContainerClassNames,
        } = this.props;
        const { isImageLoaded } = this.state;
        let seatPinIconComponents;
        const sectionClassNames = classNames(
            'eds-g-cell',
            'eds-g-cell-1-1',
            'venue-map-thumbnail__container',
            {
                [showHideClass]: !!showHideClass,
                [`venue-map-thumbnail__container--${fixedSize}`]: !!fixedSize,
            },
            __customContainerClassNames,
        );
        const imageWrapperClassNames = classNames(
            'venue-map-thumbnail__image-wrapper',
            {
                [`venue-map-thumbnail__image-wrapper--${fixedSize}`]:
                    !!fixedSize,
            },
        );

        if (!isEmpty(seatPins)) {
            seatPinIconComponents = seatPins.map((pin, index) => (
                <SeatPinIcon
                    key={index}
                    isThumbnailImageLoaded={isImageLoaded}
                    {...pin}
                />
            ));
        }

        let thumbnail = (
            <div
                className={imageWrapperClassNames}
                style={
                    customRatio ? { maxWidth: `${customRatio * 100}%` } : null
                }
            >
                <img
                    className="venue-map-thumbnail__image eds-max-img"
                    data-testid="venue-map-thumbnail-image"
                    src={thumbnailUrl}
                    alt={gettext('Venue map').toString()}
                    onLoad={this._handleImageLoad}
                />
                {seatPinIconComponents}
            </div>
        );

        if (onClick) {
            thumbnail = (
                <Button
                    style="none"
                    onClick={onClick}
                    aria-label={gettext('Buy on Map').toString()}
                >
                    {thumbnail}
                </Button>
            );
        }

        return (
            <section
                className={sectionClassNames}
                style={
                    customRatio ? { paddingTop: `${customRatio * 100}%` } : null
                }
                data-spec="venue-map-thumbnail-container"
                data-testid="venue-map-thumbnail-container"
            >
                {thumbnail}
            </section>
        );
    }
}
